<template>
  <div class="wrap">
    <b-card>
      <template #header
                v-if="title">
        <esg-card-header>
          <template #default>
            <slot name="title">
              <span class="title">{{ title }}</span>
            </slot>
          </template>
          <template #actions>
            <slot name="actions"></slot>
          </template>
        </esg-card-header>
      </template>
      <template #default>
        <slot></slot>
      </template>
    </b-card>
  </div>
</template>

<script>
import EsgCardHeader from "@/components/esg/base/EsgBaseCardHeader.vue";

export default {
  components: { EsgCardHeader },
  props: ['title']
}
</script>

<style scoped>
.wrap {
  width: 100%;
  max-width: 1400px;
  margin: auto;
  background-color: #F6F6FA;
}

.title {
  font-family: NanumGothic, serif;
  font-size: 1.375rem;
}

.card {
  background-color: #F6F6FA;
}
</style>